import {
	ProjectCarrierMapDTO,
	ProjectGroup,
	ProjectDTO,
	CarriersProjectsList,
	TruckSearchResult,
	TruckSearchTable,
	Owner,
} from 'cargo-chief-commons';
import { RANGE_FILTERS } from '@domain/constants/app-variables';
import { AllocationStatusDTO } from '@core/services/allocation/allocation.service';

export const projectDetailsPageStateKey = 'project-details-page';

export interface ProjectDetailsState {
	capacitySearchCsvDownloadInProgress: boolean;
	error: string;
	engagedCarrierIds: string[];

	projectId: string;
	projectDTO: ProjectDTO;
	customerOnlyProject: boolean;
	loadingProject: boolean;
	updatingProject: boolean;
	usersList: Owner[];

	accountCarrierLanes: any;
	loadingAccountCarrierLanes: boolean;

	loadingProjectCarrierMaps: boolean;

	// all projects
	projectsNextPage: boolean;
	isLoadingProjectsList: boolean;
	projectsPage: number;
	projectsPageSize: number;
	totalNumberOfProjects: number;
	allProjectsList: Array<ProjectDTO>;

	allProjectCarrierMapsList: ProjectCarrierMapDTO[];

	// recommended tab
	truckSearchResult: Array<TruckSearchResult>;
	numberOfLanes: number;
	allCapacitySearchResults: TruckSearchTable[];
	capacitySearchResults: TruckSearchTable[];
	loadingLanesList: boolean;
	userCarrierMapList: Array<any>;
	userCarrierMap: any;
	truckLaneSearchId: any;
	recommendedCarriersProjectsList: Array<CarriersProjectsList>;
	recommendedCarriersProjectMap: any;
	bestMatch: number;
	hasLane: boolean;

	// engaged carriers
	engagedCarriersList: ProjectCarrierMapDTO[];
	engagedCarriersCount: number;
	removingEngagedCarriersInProgress: boolean;

	// project groups
	projectGroups: ProjectGroup[];

	// procured carriers
	procuredCarriersList: ProjectCarrierMapDTO[];
	procuredCarriersCount: number;
	procuredCarriersWithoutGroupCount: number;

	// carrier allocations
	carrierAllocations: AllocationStatusDTO[];
	carrierAllocationsMap: { [carrierId: string]: AllocationStatusDTO };
	loadingCarrierAllocations: boolean;

	searchTruckForm: any;

	// filters
	originDeadhead: number;
	destinationDeadhead: number;
	powerUnits: number;
	minLoadsPerWeek: number;
	ratesOnly: boolean;
	carrierBusinessName: string;
	carrierMc: string;
	carrierDot: string;
	// CN-8312: numeric MC/DOT search value. When the user pastes a bare number
	// (e.g. copied from a card's MC: label), match it against MC OR DOT instead
	// of AND'ing both fields (which would always yield zero results).
	carrierMcOrDot: string;
	carrierSearchString: string;
	carrierHQ: string;
	matchedCarrierHqIds: string[];
	capacitySearchSort: string;
	myCarriers: boolean;
	outOfNetworkCarriers: boolean;
	qualityFilter: string;
}

export const initialState: ProjectDetailsState = {
	capacitySearchCsvDownloadInProgress: false,
	error: null,
	engagedCarrierIds: [],

	projectId: null,
	projectDTO: null,
	customerOnlyProject: false,
	loadingProject: false,
	updatingProject: false,
	usersList: [],

	accountCarrierLanes: {},
	loadingAccountCarrierLanes: false,

	loadingProjectCarrierMaps: false,

	projectsNextPage: false,
	isLoadingProjectsList: false,
	projectsPage: 0,
	projectsPageSize: 10,
	totalNumberOfProjects: null,
	allProjectsList: [],

	allProjectCarrierMapsList: [],

	truckSearchResult: null,
	numberOfLanes: 0,
	allCapacitySearchResults: [],
	capacitySearchResults: [],
	loadingLanesList: false,
	userCarrierMapList: null,
	userCarrierMap: {},
	truckLaneSearchId: null,
	recommendedCarriersProjectsList: null,
	recommendedCarriersProjectMap: {},
	bestMatch: null,
	hasLane: true,

	engagedCarriersList: [],
	engagedCarriersCount: 0,
	removingEngagedCarriersInProgress: false,

	projectGroups: [],

	procuredCarriersList: [],
	procuredCarriersCount: 0,
	procuredCarriersWithoutGroupCount: 0,

	carrierAllocations: [],
	carrierAllocationsMap: {},
	loadingCarrierAllocations: false,

	searchTruckForm: null,

	originDeadhead: null,
	destinationDeadhead: null,
	powerUnits: 0,
	minLoadsPerWeek: 0,
	ratesOnly: false,
	carrierBusinessName: '',
	carrierMc: '',
	carrierDot: '',
	carrierMcOrDot: '',
	carrierSearchString: '',
	carrierHQ: '',
	matchedCarrierHqIds: [],
	capacitySearchSort: RANGE_FILTERS.SORT.MATCH,
	myCarriers: false,
	outOfNetworkCarriers: false,
	qualityFilter: '',
};
